import { GetGameViewById } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { useGameView } from "../../api/game/GameViewSelector";
import { useAppDispatch } from "@grassrootly/rn-core";
import { gameViewActions } from "../../api/game/GameViewReducer";

export function useGameViewScreen(id: number) {
  const game = useGameView(id);
  const dispatch = useAppDispatch();

  const { loading, data } = useBaseRequest(GetGameViewById, {
    initialPayload: {
      id,
    },
    autoFetch: true,
    onCompleted: (data) => {
      if (!data) return;
      dispatch(gameViewActions.setGameView(data));
    },
  });

  // Return the game from store if available, otherwise return the data from the API call
  // This handles both cases: direct URL access and navigation from other pages
  return { loading, game: game || data };
}
